import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Observable} from "rxjs";
import {SubjectResponse} from "../../../generated-client/generated-api-client";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ErrorProcessorService} from "../../../services/error-processor.service";
import {
  isFormModifiedDataService,
  SimpleNavigationService
} from "../../../services/data-services/navigation-data-services";
import {timeout} from "rxjs/operators";

@Component({
  selector: 'app-subject-form',
  templateUrl: './subject-form.component.html',
  styleUrls: ['./subject-form.component.sass']
})
export class SubjectFormComponent implements OnInit {

  @Input() response!: Observable<SubjectResponse>;
  @Output() onSubmitCallback: EventEmitter<any> = new EventEmitter();

  subjectForm!: FormGroup;
  isLoading: boolean = true;

  constructor(
    private errorProcessorService: ErrorProcessorService,
    private _isFormModifiedDataService: isFormModifiedDataService,
    private _navigationService: SimpleNavigationService
  ) { }

  ngOnInit(): void {
    this.response?.subscribe(
      next => this.setForm(next),
      error => this.errorProcessorService.processError(error, false, true)
    );

    if (!this.response) {
      this.setForm();
    }
  }

  get id() {
    return this.subjectForm.get('id')!;
  }

  get name() {
    return this.subjectForm.get('name')!;
  }

  get description() {
    return this.subjectForm.get('description')!;
  }

  get defaultGrossTimeLimitMinutes() {
    return this.subjectForm.get('defaultGrossTimeLimitMinutes')!;
  }

  get contentLanguage() {
    return this.subjectForm.get('contentLanguage')!;
  }

  onSubmit(): void {
    this.onSubmitCallback.emit([this.subjectForm]);
  }

  onGoBack(path: string) {
    this._navigationService.navigateTo(path);
  }

  setForm(response?: SubjectResponse): void {
    this.subjectForm = new FormGroup({
      id: new FormControl(response?.id),
      name: new FormControl(response?.name),
      description: new FormControl(response?.description),
      defaultGrossTimeLimitMinutes: new FormControl(response?.defaultGrossTimeLimitMinutes, [Validators.required ,Validators.min(0)]),
      contentLanguage: new FormControl(response?.contentLanguage),
    });
    this.errorProcessorService.formGroup = this.subjectForm;
    this.subjectForm.valueChanges.subscribe(() => {
      this._isFormModifiedDataService.isFormModified = true;
    });
    this.isLoading = false;
    setTimeout(()  => {
      document.getElementById('defaultGrossTimeLimitMinutes')?.focus();
    }, 150)
  }

}
